module.exports = __webpack_public_path__ + "img/report-tip1.9a2097e1.png";